<template>
	<div>
		<div class="d-content" v-if="!modalPage">
			<div class="mask"></div>
			<div class="mask-content mask-content1">
				<div class="m-title">{{parseTitle()}}</div>
				
				<div class="m-content">
					<div class="con-item" v-for="(subItem,subIndex) in dataShow" :key="subIndex" @click="showDetail(subItem)">
						<p class="con-time"> {{subItem.date}}</p>
						<p class="con-title">{{subItem.title}}</p>
						<p class="con-moreBtn"><img src="../../static/information/moreBtn2.png"/></p>
					</div>
				</div>
			</div>
			<div class="page-buttons" v-if="pageNum>1">
			  <span class="prev-button" @click="prePage" :class="currentPage==0 ? 'disabled' :'' ">
				  <img src="../../static/prevBtn2.png"/>
			  </span>
			  <span v-for="(item, index) in pageNum" :key="index" :class="{ active: currentPage === index }">
				  
			  </span>
			  <span :class="currentPage==pageNum-1 ? 'disabled':''"  class="next-button" @click="nextPage">
			  		<img src="../../static/nextBtn2.png"/>
			  </span>
			</div>
			
		</div>
			
		<div class="d-content" v-if="modalPage">
			<div class="mask"></div>
			<div class="mask-content">
				<el-row type="flex" justify="space-around" :gutter="24" class="m-title">
					{{newsInfo.title}}
				</el-row>
				<el-row type="flex" class="row-bg" justify="space-around">
					时间：{{newsInfo.date}}&nbsp;&nbsp;&nbsp;&nbsp;
					来源 ：{{newsInfo.source}}
					<!-- 访问量 ：{{newsInfo.visits}} -->
				</el-row>
				<div  v-html="newsInfo.content"></div>
			</div>
			<div class="close-button" @click="closeDetail()"><i class="el-icon-circle-close"></i></div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'InformationSecond',
		props: {
			list: {
				type: Array,
				required: true
			}
		},
		data() {
			return {
				activeIndex: 0,
				baseUrl: 'http://kingstronbio.slinqueen.com',
				newsInfo:{},
				modalPage: false,
				pageSize: 10,
				currentPage: 0,
			}
		},
		computed: {
			// visiblePrev() {
			// 	return this.list.length > 1
			// },
			// visibleNext() {
			// 	return this.list.length > 1
			// },
			dataShow: function(){
				let start = this.currentPage*this.pageSize;
				let end = Math.min((this.currentPage+1)*this.pageSize, this.list.length)
				return this.list.slice(start, end)
			},
			pageNum: function(){
				return Math.ceil(this.list.length / this.pageSize) || 1 ;
			}
		},
		methods: {
			closeModal() {
				this.$parent.hideModal();
			},
			backPrevMenu() { //返回上级目录
				this.$parent.closePage();
			},
			setActiveItem(index) {
				this.$refs.carousel.setActiveItem(index);
			},
			showDetail(item){
				this.modalPage = true;
				this.newsInfo = item;
			},
			closeDetail(){
				this.modalPage = false;
			},
			parseImg(img) {
				return this.baseUrl + img;
			},
			nextPage(){
				var vm = this;
				if (vm.currentPage == vm.pageNum - 1) return;
				vm.currentPage++;
			},
			prePage(){
				var vm = this;
				if (vm.currentPage == 0) return;
				vm.currentPage--;
			},
			toPage(page){
				var vm = this;
				vm.currentPage = page
			},
			parseTitle(){
				if(this.activeIndex == 1){
					return "科普知识"
				}else if(this.activeIndex == 2){
					return "临床病例"
				}else{
					return "公司新闻"
				}
			},
			hideModal() {
				this.modalVisible = false;
				// this.activeBtn = null;
			}
		},
		mounted() {
			var that = this;
			that.activeIndex = that.$route.params.mid ? that.$route.params.mid : '0';
		}
	}
</script>

<style lang="less" scoped>
	// @import '~bootstrap/dist/css/bootstrap.css';
	@import '../assets/css/index';
	@import '../assets/css/style';
	.d-content {
		.scale(1681, 967);
		.pos-a(0, 0, 6);

		.mask {
			.pos-a(0, 0, 4);
			width: 100%;
			height: 100%;
			background-color: #e5e3e1;
		}
		.m-title {
			font-size: 30/@r;
			margin: 20/@r auto;
			font-weight: bold;
			cursor: pointer;
		}

		.m-avator {
			.scale(250, 129);
		}

		.mask-content {
			.pos-a-center();
			width: 70%;
			height: 100%;
			z-index: 5;
			background: #fff;
			padding: 0 50/@r;
			overflow-y: auto;
			font-size: 18/@r;
			overflow-x: hidden;
			.con-title{
				font-size: 20/@r !important;
				font-weight: 600;
			}
			video{
				width: 100% !important;
			}
		}
		.mask-content::-webkit-scrollbar {
		    /* 对应纵向滚动条的宽度 */
		    width: 10/@r;
		    /* 对应横向滚动条的宽度 */
		    height: 20/@r;
		}
		
		/* 滚动条上的滚动滑块 */
		.mask-content::-webkit-scrollbar-thumb {
		    background-color: #49b1f5;
		    border-radius: 32px;
		}
		
		/* 滚动条轨道 */
		.mask-content::-webkit-scrollbar-track {
		    background-color: #dbeffd;
		    border-radius: 32px;
		}
		

		.close-button {
			position: absolute;
			top: 20/@r;
			right: 42/@r;
			font-size: 58/@r;
			cursor: pointer;
			// transition: color 0.3s;
			z-index: 6;
		}
	}
	.mask-content1{
		background-color: #e5e3e1 !important;
		width: 1366/@r !important;
		.m-content{
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
		}
		.m-title{
			margin-top: 40/@r;
			font-size: 30/@r;
			color: #4d4d4d;
			margin-bottom: 10/@r !important;
		}
		.con-item {
			border-bottom: 1px solid #767574;
			font-size: 20/@r;
			width: 634/@r;
			// min-height: 136/@r;
			position: relative;
			color: #4d4d4d;
			cursor: pointer;
			.con-time{
				font-size: 15/@r;
			}
			.con-title{
				margin: 0;
				font-size: 18/@r;
				overflow: hidden;
				  text-overflow: ellipsis;
				  display: -webkit-box;
				  -webkit-line-clamp: 2;
				  -webkit-box-orient: vertical;
				  display: -moz-box;
				  -moz-line-clamp: 2;
				  -moz-box-orient: vertical;
				  word-wrap: break-word;
				  word-break: break-all;
				  white-space: normal;    
			}
		}
		
		.con-moreBtn{
			// position: absolute;
			// bottom: 0/@r;
			margin: 10/@r 0;
			.scale(120, 29);
			display: block;
		}
		p{
			margin-top: 10/@r;
		}
	}
	.page-buttons {
	  position: absolute;
	  left: 50%;
	  top: 91% !important;
	  height: 50/@r;
	  transform: translateX(-50%);
	  display: flex;
	  justify-content: space-between;
	  align-items: center;
	  .prev-button,.next-button{
		   .scale(43*180/63,43);
		   background-color: transparent;
		   &.disabled{
				background: rgba(255, 255, 255, 0.2);
				cursor: not-allowed;
				filter: grayscale(1);
				pointer-events: none;
		   }
	  }
	  span{
		 .scale(8,8);
		  border-radius: 50%;
		  display: inline-block;
		  background-color: #8b8b8b;
		  margin: 0 10/@r;
		  &.active{
			  .scale(20,7);
			  background-color: #3f8eba;
			  border-radius: 10/@r;
		  }
	  }
	}

	.el-row {
		margin: 20/@r auto;
	}
</style>
